:host {
  /**
   * @prop --c-tab-border-color-active: Active tab bottom border color
   * @prop --c-tab-background-color-hover: Tab hover background color
   * @prop --c-tab-outline-color: Tab outline color
   * @prop --c-tab-text-color: Tab text color
   */
  --_c-tab-border-color-active: var(--c-tab-border-color-active, var(--_c-tab-text-color));
  --_c-tab-background-color-hover: var(--c-tab-background-color-hover, var(--c-primary-100));
  --_c-tab-outline-color: var(--c-tab-outline-color, var(--_c-tab-text-color));
  --_c-tab-text-color: var(--c-tab-text-color, var(--c-primary-600));

  display: block;
  user-select: none;
  min-width: min-content;
  flex-grow: 1;

  div.c-tab__content {
    align-items: center;
    justify-content: center;
    display: flex;
    height: 100%;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    padding-inline: 12px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

:host(:focus) {
  outline: none;
}

:host(:focus-visible) {
  border-radius: 4px;
  outline: 2px var(--_c-tab-outline-color) solid;
  outline-offset: 2px;
}

:host([role="tab"][aria-disabled="true"]) {
  cursor: default !important;
}

slot {
  pointer-events: none;
}

:host(.c-tab) {
  align-items: center;
  color: var(--_c-tab-text-color);
  cursor: pointer;
  display: inline-flex;
  font-weight: 600;
  height: 52px;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

:host(.c-tab:hover) {
  background-color: var(--_c-tab-background-color-hover);
}

:host(.c-tab--active) {
  // box-shadow: inset 0 -3px 0 0 var(--_c-tab-border-color-active);
}

:host(.c-tab--active:hover) {
  background-color: transparent !important;
}

:host(.c-tab--disabled) {
  color: var(--c-tertiary-500);
  cursor: default;
  opacity: 0.75;
  pointer-events: none;
}

:host(.c-tab button) {
  appearance: none;
  background-color: transparent;
  border: none;
  color: inherit;
  cursor: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
